
function calendarPrice(){
  $(document).delegate('#ticketCalenderPrice', 'focus',function () {
    console.log(1111);
    var parent = $(this).closest('section');
    parent.find('.chidren-select-wrap').show();
    parent.find('.calendar-price-wrap').slideToggle('fast');
  })
}



module.exports = {
	run: function () {
		//存储用户每天加床、加宽带的数目
    //calendarPrice()

	}
};



// WEBPACK FOOTER //
// ./src/js/ticketOrderConfirm/modules/extraService.js